// extracted by mini-css-extract-plugin
export default {"icon":"CloseIcon_icon__7qps3","button":"CloseIcon_button__TwJD-"};